import { Capa } from '../solucion/Capa.entity';
import { Dimension } from '../solucion/Dimension.entity';
import { Etapa } from '../diagnostico/Diagnostico.entity';
import { User } from '../shared/user.model';

export class Pregunta {
  constructor(
    public preguntasID: number,
    public descripcion: string,
    public dimensionID: number,
    public dimension: Dimension,
    public etapa: Etapa,
    public etapaID: number,
    public capa: Capa,
    public capaId: number,
    public AyudaID: number,
    public activa: boolean,
    public respuestaTipoID: number,
    public respuestaTipo: RespuestaTipo,
    public completa: boolean
    ) {}
  }
  export class Cuestionario {
    public pregunta: Pregunta[];
    public presentacionok = false;
    constructor() {}
    }
  export class Respuesta {
      constructor(
        public respuestasValorID: number,
        public cliente: User ,
        public clienteID: number,
        public respuestaTipoID: number,
        public respuestaTipoOpcionID: number,
        public respuestaTipoOpciones: RespuestaTipoOpciones,
        public pregunta: Pregunta,
        public preguntasID: number,
        public etapa: Etapa,
        public etapaID: number,
        public diagnosticoID: number,
        public valor: string ) {}
      }
export class RespuestaTipo {
  constructor(
    public respuestaTipoID: number,
    public respuestaDescripcion: string ,
    public respuestaTipoEnum: number) {}
  }

  export class RespuestaTipoOpciones {
    constructor(
      public respuestaTipoOpcionID: number,
      public respuestaTipoID: number,
      public respuestaOpcion: string ) {}
    }



// WEBPACK FOOTER //
// ./src/app/cuestionario/cuestionario.entity.ts